<template>
  <div class="animated fadeIn">
    <span v-show="false">{{ reactivity }}</span>
    <!-- loading component -->
    <!-- <Loading /> -->
    <b-card style="border: 0">
      <b-row>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <b-col>
            <b-form-group label="عنوان درخواست *">
              <b-form-input
                trim
                type="text"
                v-model="newrequest.faSubject"
                class="form-control"
              >
              </b-form-input>
            </b-form-group>
          </b-col>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <b-col>
            <b-form-group label="کد رهگیری درخواست در سامانه خدمت">
              <b-form-input
                trim
                type="number"
                v-model="newrequest.requestTrackingCode"
                class="form-control"
              />
            </b-form-group>
          </b-col>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <b-col>
            <b-form-group label="آپلود فایل ورد پروپوزال*">
              <b-form-file
                ref="proposalFile"
                class="form-control"
                browse-text="بارگذاری"
                placeholder="فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)"
                accept=".doc,.docx"
                @input="uploadProposal(file)"
              >
              </b-form-file>
            </b-form-group>

            <b-button
              id="downLoad"
              variant="link"
              href="/researcher/Proposalform.doc"
            >
              <b-tooltip
                placement="bottomleft"
                target="downLoad"
                triggers="hover"
                variant="info"
                >دانلود نمونه فایل</b-tooltip
              >
              نمونه فایل پروپوزال
            </b-button>
          </b-col>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <b-col>
            <b-form-group label="آپلود نامه دانشگاه">
              <b-form-file
                ref="universityLetterFile"
                class="form-control"
                browse-text="بارگذاری"
                placeholder="فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)"
                accept=".doc,.docx"
                @input="uploadUniversityLetter(file)"
              >
              </b-form-file>
            </b-form-group>
          </b-col>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <b-col>
            <v-btn
              @click="submit()"
              :loading="loading"
              :disabled="busy || !newrequest.faSubject || !proposalFileId"
              class="mt-5 green-btn"
              variant="success"
            >
              ذخیره اطلاعات
            </v-btn>
          </b-col>
        </div>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "newRequestForm",
  mounted() {},
  data() {
    return {
      proposalFileId: null,
      universityLetterFileId: null,
      file: [],
      profileFiles: [],
      mainFileLoading: false,
      busy: false,
      newrequest: {},
      myFilepro: new Object({
        uploadPercentage: 0,
      }),
      showProgress: false,
      striped: true,
      reactivity: false,
      isUploaded: false,
      max: 100,
      loading: false,
    };
  },
  methods: {
    submit() {
      if (!this.proposalFileId) {
        this.toast("error", "error");
      } else {
        this.busy = true;
        this.loading = true;
        const model = {
          faSubject: this.newrequest.faSubject,
          requestTrackingCode: this.newrequest.requestTrackingCode,
          proposalFileId: this.proposalFileId.id,
          // universityLetterFileId: this.universityLetterFileId.id,
        };
        this.$http
          .post(
            this.baseUrl + "/setad/researcher/request/project/newV2",
            model,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.toast(res.data, "success");
            if (res.status == 201) {
              this.toast(res.data, "success");
              this.clearForm();
              this.$set(this, "proposalFileId", null);
              this.busy = false;
              this.loading = false;
            } else {
              this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
              this.loading = false;
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast("خطا: " + err.response.data, "error");

            this.busy = false;
            this.loading = false;
          });
      }
    },
    clearForm() {
      this.newrequest.faSubject = "";
      this.newrequest.requestTrackingCode = "";
      this.proposalFileId = null;
      this.universityLetterFileId = null;
      this.file = []; // Reset file array

      // Add this if you want to reset the file inputs
      this.$refs.proposalFile.reset();
      this.$refs.universityLetterFile.reset();
    },
    uploadProposal(file) {
      if (!file) {
        this.toast("error", "error");
        return;
      }
      //CHECK FILE SIZE
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast(
          "حجم فایل " + file.name + " نباید از 5 مگابایت بیشتر باشد",
          "error"
        );
        return;
      } else {
        let proposalFile = this.$refs.proposalFile.files[0];
        // if (!proposalFile) {
        //   console.log("No proposal file uploaded.");
        //   return;
        // }
        let formData = new FormData();
        formData.append(
          "file",
          proposalFile,
          proposalFile.name,
          file.name,
          file
        );
        this.$http
          .post(
            this.baseUrl + "/setad/researcher/request/project/uploadDraft",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.proposalFileId = res.data;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },

    uploadUniversityLetter(file) {
      if (!file) {
        this.toast("error", "error");
        return;
      }
      //CHECK FILE SIZE
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast(
          "حجم فایل " + file.name + " نباید از 5 مگابایت بیشتر باشد",
          "error"
        );
        return;
      } else {
        let universityLetterFile = this.$refs.universityLetterFile.files[0];
        // if (!universityLetterFile) {
        //   console.log("No proposal file uploaded.");
        //   return;
        // }
        let formData = new FormData();
        formData.append(
          "file",
          universityLetterFile,
          universityLetterFile.name,
          file.name,
          file
        );
        this.$http
          .post(
            this.baseUrl + "/setad/researcher/request/project/uploadDraft",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.universityLetterFileId = res.data;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },
};
</script>
<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
</style>

<style lang="scss" scoped>
.btn-light {
  color: #1f618d !important;
  background-color: #eaf2f8 !important;
  transition: 0.3s all ease-in-out;
  margin-bottom: 15px;
  padding: 15px;
  border-radius: 8px !important;
  border: 0;
  box-shadow: 0px 0px 15px #154360;

  &:hover {
    color: #fff !important;
    box-shadow: none;
    transition: 0.3s all ease-in-out;
    background: linear-gradient(200deg, #154360 0%, #5499c7 100%);
  }
}
.btn-yahoo {
  color: #4a235a !important;
  background-color: #d9d0db !important;
  transition: 0.3s all ease-in-out;
  margin-bottom: 15px;
  padding: 15px;
  box-shadow: 0px 0px 15px #4a235a;
  border-radius: 8px !important;
  border: 0;

  &:hover {
    color: #fff !important;
    box-shadow: none;
    transition: 0.3s all ease-in-out;
    background: linear-gradient(200deg, #4a235a 0%, #9954c7 100%);
  }
}
</style>
